export default "__VITE_ASSET__mCaodbQf__"